(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milora-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('milora-reviews')){
  customElements.define('milora-reviews',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.cards=Array.from(this.querySelectorAll('[data-review]'));
      if(!this.cards.length)return;
      this.pageSize=Number(this.dataset.size)||6;this.limit=this.pageSize;this.rating=0;this.photos=false;
      this.list=this.querySelector('[data-list]');this.more=this.querySelector('[data-load-more]');this.sort=this.querySelector('[data-sort]');
      this.querySelector('.mr__controls').hidden=false;
      this.querySelectorAll('[data-rating].mr__bar').forEach(button=>button.addEventListener('click',()=>{this.rating=this.rating===Number(button.dataset.rating)?0:Number(button.dataset.rating);this.limit=this.pageSize;this.update();}));
      this.querySelector('[data-all]').addEventListener('click',()=>{this.rating=0;this.photos=false;this.limit=this.pageSize;this.update();});
      this.querySelector('[data-photos]')?.addEventListener('click',()=>{this.photos=!this.photos;this.limit=this.pageSize;this.update();});
      this.sort.addEventListener('change',()=>{this.limit=this.pageSize;this.update();});
      this.more.addEventListener('click',()=>{this.limit+=this.pageSize;this.update();});
      this.cards.forEach(card=>{const body=card.querySelector('[data-body]'),button=card.querySelector('[data-expand]');if(this.dataset.collapse!=='false'&&body.textContent.length>230){body.classList.add('is-clamped');button.hidden=false;button.addEventListener('click',()=>{const expanded=button.getAttribute('aria-expanded')!=='true';body.classList.toggle('is-clamped',!expanded);button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?button.dataset.less:button.dataset.more;});}});
      this.update();
    }
    update(){
      const sorted=[...this.cards].sort((a,b)=>{if(this.sort.value==='manual')return 0;if(this.sort.value!=='newest'){if(!Number(a.dataset.rating))return Number(b.dataset.rating)?1:0;if(!Number(b.dataset.rating))return -1;}if(this.sort.value==='highest')return Number(b.dataset.rating)-Number(a.dataset.rating);if(this.sort.value==='lowest')return Number(a.dataset.rating)-Number(b.dataset.rating);return (Date.parse(b.dataset.date)||0)-(Date.parse(a.dataset.date)||0);});
      const matched=sorted.filter(card=>(!this.rating||Number(card.dataset.rating)===this.rating)&&(!this.photos||card.dataset.photo==='true'));
      const visible=new Set(matched.slice(0,this.limit));
      sorted.forEach(card=>{card.hidden=!visible.has(card);this.list.appendChild(card);});
      this.querySelectorAll('.mr__bar').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.rating)===this.rating)));
      this.querySelector('[data-all]').setAttribute('aria-pressed',String(!this.rating&&!this.photos));
      this.querySelector('[data-photos]')?.setAttribute('aria-pressed',String(this.photos));
      const status=this.querySelector('[data-status]');status.textContent=status.dataset.template.replace('[shown]',String(visible.size)).replace('[total]',String(matched.length));
      this.querySelector('[data-no-results]').hidden=matched.length>0;this.more.hidden=matched.length<=this.limit;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milora-stories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('milora-stories'))customElements.define('milora-stories',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.track=this.querySelector('[data-track]');this.cards=[...this.querySelectorAll('[data-story]')];this.nav=this.querySelector('[data-nav]');if(!this.nav)return;this.nav.hidden=false;this.index=0;this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.prev.addEventListener('click',()=>this.move(-1));this.next.addEventListener('click',()=>this.move(1));this.track.addEventListener('scroll',()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;const edge=this.track.getBoundingClientRect().right;this.index=this.cards.reduce((best,card,i)=>Math.abs(edge-card.getBoundingClientRect().right)<Math.abs(edge-this.cards[best].getBoundingClientRect().right)?i:best,0);this.update();});},{passive:true});this.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-story]');if(card)card.scrollIntoView({block:'nearest',inline:'start',behavior:'auto'});});this.update();}
  move(step){this.index=Math.max(0,Math.min(this.cards.length-1,this.index+step));this.cards[this.index].scrollIntoView({block:'nearest',inline:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.update();}
  update(){this.prev.disabled=this.index===0;this.next.disabled=this.index===this.cards.length-1;this.querySelector('[data-position]').textContent=(this.index+1)+' / '+this.cards.length;}
  disconnectedCallback(){if(this.frame)cancelAnimationFrame(this.frame);}
});

  } catch(e) { console.error(e); }
})();
})();
